import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";

import { connect } from "react-redux";

import { messageService } from "services";
import { title, List } from "utils";

import { Header, MessageGroup } from "components";
import { Button, Input } from "antd";

class ChatPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      groups: [],
      newMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMessageSend = this.handleMessageSend.bind(this);
    this.groupMessages = this.groupMessages.bind(this);
  }

  componentDidMount() {
    this.fetchMessages();
  }

  async fetchMessages() {
    const messages = await messageService.list();
    this.setState(
      {
        messages: messages,
      },
      () => this.groupMessages(),
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.state?.fromNotif != null &&
      this.props.location.state.fromNotif !== prevProps.location.state?.fromNotif
    ) {
      this.fetchMessages();
    }
  }

  handleInputChange(value) {
    this.setState({ newMessage: value });
  }

  async handleMessageSend(e) {
    e.preventDefault();

    const { newMessage } = this.state;
    if (newMessage.length === 0) return;

    const response = await messageService.create({
      text: newMessage,
      user_id: this.props.user.id,
      date: new Date(),
    });

    this.setState(
      {
        messages: [...this.state.messages, response],
        newMessage: "",
      },
      () => this.groupMessages(),
    );
  }

  groupMessages() {
    const { messages } = this.state;

    let groups = [];
    let current = {
      user: null,
      user_id: null,
      messages: [],
      date: null,
    };

    messages.forEach((message, i) => {
      let diff = moment(current.date).diff(message.date, "minutes");

      if (!current.date || diff < -2 || current.user_id !== message.user_id) {
        if (i !== 0) groups.push({ ...current });

        current.user = message.user;
        current.user_id = message.user_id;
        current.messages = [message.text];
        current.date = message.date;
      } else {
        current.messages.push(message.text);
        current.date = message.date;
      }
    });

    if (current.user_id !== null) groups.push(current);

    this.setState({ groups });
    window.scrollTo(0, 0);
  }

  render() {
    const { groups, newMessage } = this.state;

    return (
      <Fragment>
        <Helmet>
          {title("Messages")}
          <body data-chat="true" />
        </Helmet>

        <div className="chat-page main-content">
          <Header title="Messages" />

          <div className="messages-list">
            {groups.map((group, i) => (
              <MessageGroup key={i} from={group.user} messages={group.messages} date={group.date} />
            ))}

            <form className="message-create" onSubmit={this.handleMessageSend}>
              <Input.TextArea
                autoSize={{ minRows: 1, maxRows: 3 }}
                onChange={(e) => this.handleInputChange(e.target.value)}
                onPressEnter={this.handleMessageSend}
                value={newMessage}
              />
              <Button htmlType="submit" type="primary" shape="circle" icon="message" />
              <Button
                type="primary"
                shape="circle"
                icon="reload"
                onClick={() => window.location.reload()}
              />
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(ChatPage);
